module.exports = __webpack_public_path__ + "e1f032cbe1aa21925bda7a79a058f410.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-20.png
// module id = 2700
// module chunks = 0